export default __webpack_public_path__ + "static/media/99.eccb4a05.svg";